"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tags = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

var _Box = require("../Box");

var _Flex = require("../Flex");

var _Join = require("../Join");

var _Link = require("../Link");

var _Typography = require("../Typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Use tags for genes and categories that relate to an Artist or Artwork.
 * @deprecated
 */
var Tags = function Tags(_ref) {
  var tags = _ref.tags,
      _ref$displayNum = _ref.displayNum,
      displayNum = _ref$displayNum === void 0 ? tags.length : _ref$displayNum;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var _useState3 = (0, _react.useState)("auto"),
      _useState4 = _slicedToArray(_useState3, 2),
      boxHeight = _useState4[0],
      setBoxHeight = _useState4[1];

  var flexContainer = (0, _react.useRef)(null);
  var animatingBox = (0, _react.useRef)(null); // after animating AnimatingBox height set back height to auto (to handle screen resize etc.)

  (0, _react.useEffect)(function () {
    animatingBox.current.addEventListener("transitionend", function (e) {
      var isAnimatingBoxTransition = e.target === animatingBox.current;

      if (isAnimatingBoxTransition) {
        setBoxHeight("auto");
      }
    });
  }, []);
  var sliceSize = expanded ? tags.length : displayNum;
  var tagEls = tags.slice(0, sliceSize).map(function (tag, i) {
    return /*#__PURE__*/_react.default.createElement(Tag, _extends({
      key: i
    }, tag));
  });
  /**
   * By default AnimationBox height is auto. for open/close transition:
   * 1. explicitly set the height to be the same as the flex container inside it,
   * 2. display new tags (setExpanded(true))
   * 3. set the height to the new flexContainer height so the animation triggers
   */

  var toggleMore = function toggleMore() {
    var BORDER_OFFSET = 2;
    var oldHeight = flexContainer.current.offsetHeight - BORDER_OFFSET;
    setBoxHeight(oldHeight + "px");
    setExpanded(!expanded); // wait for a tick

    setTimeout(function () {
      var newHeight = flexContainer.current.offsetHeight - BORDER_OFFSET;
      setBoxHeight("".concat(newHeight, "px"));
    }, 10);
  };

  var moreButton = displayNum < tags.length && !expanded && /*#__PURE__*/_react.default.createElement(MoreTag, {
    count: tags.length - displayNum,
    onClick: toggleMore
  });

  return /*#__PURE__*/_react.default.createElement(AnimatingBox, {
    height: boxHeight,
    ref: animatingBox
  }, /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    flexWrap: "wrap",
    mb: -0.5,
    ref: flexContainer
  }, /*#__PURE__*/_react.default.createElement(_Join.Join, {
    separator: /*#__PURE__*/_react.default.createElement(_Box.Box, {
      pl: 0.5
    })
  }, tagEls, moreButton)));
};

exports.Tags = Tags;
Tags.displayName = "Tags";
var AnimatingBox = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Tags__AnimatingBox",
  componentId: "sc-1aqkapz-0"
})(["transition:height 0.25s ease;overflow:hidden;"]);

var Tag = function Tag(_ref2) {
  var name = _ref2.name,
      href = _ref2.href;
  return /*#__PURE__*/_react.default.createElement(_Link.Link, {
    href: href,
    underlineBehavior: "none"
  }, /*#__PURE__*/_react.default.createElement(TagBox, null, name));
};

Tag.displayName = "Tag";
var tagsBoxMargins = {
  px: 1,
  py: 0.5,
  mb: 0.5
};

var TagBox = function TagBox(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/_react.default.createElement(HoverBox, tagsBoxMargins, /*#__PURE__*/_react.default.createElement(_Typography.Sans, {
    size: "2",
    color: "black60"
  }, children));
};

TagBox.displayName = "TagBox";

var MoreTag = function MoreTag(_ref4) {
  var onClick = _ref4.onClick,
      count = _ref4.count;
  return /*#__PURE__*/_react.default.createElement(MoreBox, _extends({}, tagsBoxMargins, {
    onClick: onClick
  }), /*#__PURE__*/_react.default.createElement(_Typography.Sans, {
    size: "2",
    color: "black60"
  }, "+", count, " more"));
};

MoreTag.displayName = "MoreTag";
var HoverBox = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Tags__HoverBox",
  componentId: "sc-1aqkapz-1"
})(["border:1px solid ", ";border-radius:2px;background-color:", ";&:hover{background-color:", ";border-color:", ";}transition:all 0.25s;"], (0, _helpers.color)("black5"), (0, _helpers.color)("black5"), (0, _helpers.color)("black10"), (0, _helpers.color)("black10"));
var MoreBox = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Tags__MoreBox",
  componentId: "sc-1aqkapz-2"
})(["border:1px solid ", ";border-radius:2px;&:hover{border-color:", ";}transition:all 0.25s;cursor:pointer;"], (0, _helpers.color)("black5"), (0, _helpers.color)("black10"));
//# sourceMappingURL=Tags.js.map